import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { getHelpData, getPdf } from "../../api/helpApi/helpApi";
import FooterImg from "../../assets/images/Footer.png";
import LocalStorageUtil from "../../utils/localStorage";
interface CustomModalProps {
  open: boolean;
  onClose: () => void;
}

const HelpModal: React.FC<CustomModalProps> = ({ open, onClose }) => {
  const [data, setData] = useState<any>([]);
  const [, setLoading] = useState<boolean>(false); // NOSONAR
  const fetchHelpData = async () => {
    try {
      setLoading(true);  
      const payload = {
        AccountId: LocalStorageUtil.getItem("accountId"),
        ContextName: LocalStorageUtil.getItem("contextName"),
      };
      const response = await getHelpData(payload);
      setData(response);
    } catch (error) {
      console.log("Failed to load help data:", error);
    } finally {
      setLoading(false); 
    }
  };


  const handleDownloadPdf = async () => {
    try {
      const payload = {
        contextName: LocalStorageUtil.getItem("contextName"),
        helpDocumentId: helpModel?.helpDocumentId,
      };
      const response = await getPdf(payload);
      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `HelpDocument.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error while downloading PDF:", error);
    }
  };

  useEffect(() => {
    if (open && data !== null) {
      fetchHelpData();
    }
  }, [open]);

  const helpModel = data?.helpModel?.[0];
  const contact = data?.contact?.[0];
  return (
    <Modal
      open={open}
      onClose={() => {}}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "39%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#006ab6",
            color: "white",
            padding: "8px 16px",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        >
          <Typography id="custom-modal-title" style={{ fontWeight: "bold" }}>
            Help
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{ color: "white", fontWeight: "bold" }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ pl: 2, pr: 2, pt: 2 }}>
          <Typography
            id="custom-modal-description"
            variant="body2"
            style={{ textTransform: "uppercase", color: "#006ab6" }}
            className="text-size"
          >
            Help Documentation
          </Typography>
          <hr
            style={{
              border: 0,
              borderTop: "1px dashed #2678c4",
            }}
          />
          <Typography
            style={{ color: "#006ab6" }}
            onClick={handleDownloadPdf}
            onMouseOver={(e) => {
              e.currentTarget.style.textDecoration = "underline";
              e.currentTarget.style.cursor = "pointer";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.textDecoration = "none";
              e.currentTarget.style.cursor = "pointer";
            }}
            data-testid="download-pdf"
          >
            <span
              style={{ fontWeight: "bold", color: "black" }}
              className="text-size"
            >
              1.
            </span>
            <span className="text-size">
            {helpModel?.documentName}{helpModel?.fileType}
            </span>
          </Typography>
          <Typography>
            <span className="text-size">{helpModel?.documentName}</span>
          </Typography>
        </Box>
        <Box sx={{ pl: 2, pr: 2, pt: 2 }}>
          <Typography>
            <span style={{ fontWeight: "bold" }} className="text-size">
              DocDistro:{" "}
            </span>
            <a
              href="https://docdistro-stage.dfsco.com/docdistro/swagger/ui/index"
              target="_blank"
              style={{
                color: "#006ab6",
                textDecoration: "none",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.textDecoration = "underline";
              }}
              onFocus={(e) => {
                e.currentTarget.style.textDecoration = "underline";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.textDecoration = "none";
              }}
              onBlur={(e) => {
                e.currentTarget.style.textDecoration = "none";
              }}
              className="text-size"
            >
              API Portal
            </a>
          </Typography>
        </Box>
        <Box sx={{ pl: 2, pr: 2, pt: 2 }}>
          <Typography>
            <span style={{ fontWeight: "bold" }} className="text-size">
              Technical Support
            </span>
          </Typography>
          <Typography>
            <span className="text-size">Name: </span>
            <span className="text-size">{contact?.childContactName}</span>
          </Typography>
          <Typography>
            <span className="text-size">Phone: </span>
            <span className="text-size">{contact?.childPhone}</span>
          </Typography>
          <Typography>
            <span className="text-size">Email: </span>
            <span className="text-size">{contact?.childEmail}</span>
          </Typography>
        </Box>
        <Box sx={{ pl: 2, pr: 2, pt: 2 }}>
          <Typography>
            <span style={{ fontWeight: "bold" }} className="text-size">
              About DocDistro
            </span>
          </Typography>
          <Typography>
            <span className="text-size">Version: </span>
            <span className="text-size">DocDistro</span>
          </Typography>
          <Typography>
            <span className="text-size">Build: </span>
            <span className="text-size">Version 1.0.0.0</span>
          </Typography>
        </Box>
        <Box sx={{ p: 2 }}>
          <Typography>
            <CopyrightIcon />
            <span style={{ marginRight: "10px" }} className="text-size">
              2016
            </span>
            <img
              style={{ width: "170px" }}
              src={FooterImg}
              alt="Powered by Doc-Distro"
            />
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default HelpModal;
